"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Download_exports = {};
__export(Download_exports, {
  default: () => Download_default
});
module.exports = __toCommonJS(Download_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.41016 12.5742C3.55339 12.5742 3.67057 12.6263 3.76172 12.7305C3.86589 12.8216 3.91797 12.9323 3.91797 13.0625V15.6992C3.91797 16.0247 4.02865 16.3047 4.25 16.5391C4.48438 16.7604 4.76432 16.8711 5.08984 16.8711H15.9102C16.2357 16.8711 16.5091 16.7604 16.7305 16.5391C16.9648 16.3047 17.082 16.0247 17.082 15.6992V13.0625C17.082 12.9323 17.1276 12.8216 17.2188 12.7305C17.3229 12.6263 17.4466 12.5742 17.5898 12.5742C17.7201 12.5742 17.8307 12.6263 17.9219 12.7305C18.026 12.8216 18.0781 12.9323 18.0781 13.0625V15.6992C18.0781 16.2982 17.8633 16.8125 17.4336 17.2422C17.0169 17.6589 16.5091 17.8672 15.9102 17.8672H5.08984C4.49089 17.8672 3.97656 17.6589 3.54688 17.2422C3.13021 16.8125 2.92188 16.2982 2.92188 15.6992V13.0625C2.92188 12.9323 2.96745 12.8216 3.05859 12.7305C3.16276 12.6263 3.27995 12.5742 3.41016 12.5742ZM10.5781 2.82812C10.7214 2.82812 10.8385 2.88021 10.9297 2.98438C11.0339 3.07552 11.0859 3.19271 11.0859 3.33594V13.3359C11.0859 13.4661 11.0339 13.5833 10.9297 13.6875C10.8385 13.7786 10.7214 13.8242 10.5781 13.8242C10.4349 13.8242 10.3112 13.7786 10.207 13.6875C10.1159 13.5833 10.0703 13.4661 10.0703 13.3359V3.33594C10.0703 3.19271 10.1159 3.07552 10.207 2.98438C10.3112 2.88021 10.4349 2.82812 10.5781 2.82812ZM13.8398 10.6797C13.944 10.7839 13.9961 10.9076 13.9961 11.0508C13.9961 11.181 13.9505 11.2982 13.8594 11.4023L10.9688 14.2734C10.8516 14.3906 10.7083 14.4492 10.5391 14.4492C10.3828 14.4492 10.2461 14.3906 10.1289 14.2734L7.23828 11.4219C7.13411 11.3177 7.08203 11.2005 7.08203 11.0703C7.08203 10.9271 7.1276 10.8099 7.21875 10.7188C7.32292 10.6146 7.4401 10.5625 7.57031 10.5625C7.71354 10.5625 7.83724 10.6081 7.94141 10.6992L10.5391 13.2773L13.1367 10.6992C13.2409 10.5951 13.3581 10.543 13.4883 10.543C13.6315 10.543 13.7487 10.5885 13.8398 10.6797Z",
      fill: "currentColor"
    }
  )
);
const SvgDownload = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var Download_default = SvgDownload;
